import { Flex, type TextProps } from "@mantine/core";
import Link from "next/link";

import { Text, Title } from "@/components/ui/elements";

type Props = {
  icon: React.ReactNode;
  label: string | React.ReactNode;
  title?: string;
  align?: React.CSSProperties["alignContent"];
  labelProps?: TextProps;
  url?: string;
};

export function IconLabel(props: Props) {
  const { icon, label, title, align, labelProps, url } = props;
  return (
    <Flex align={align ? align : "center"} gap={5}>
      <Flex align={align ? align : "center"} py={4}>
        {icon}
      </Flex>
      <div>
        {title && <Title.H4>{title}</Title.H4>}
        {url ? (
          <Text style={{ whiteSpace: "pre-wrap" }} {...labelProps}>
            <Link target="_blank" href={url}>
              {label}
            </Link>
          </Text>
        ) : (
          <Text style={{ whiteSpace: "pre-wrap" }} {...labelProps}>
            {label}
          </Text>
        )}
      </div>
    </Flex>
  );
}
